import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DocumentEmailReadService } from 'src/app/application/service/DocumentEmailReadService';
import { DocumentEmailReadReportParams } from 'src/app/domain/models/DocumentEmailRead';
import { Routes } from 'src/app/infrastructure/routes';
import { excelUtils } from 'src/app/ui/util/excel-utils';

@Component({
  selector: 'app-admin-downloaded-documents-report',
  templateUrl: './admin-downloaded-documents-report.component.html',
  styleUrls: ['./admin-downloaded-documents-report.component.css']
})
export class AdminDownloadedDocumentsReportComponent {
  loadingBtnDownload: boolean = false;

  form: FormGroup = this._formBuilder.group({
    startDate: [null, Validators.required],
    endDate: [null, Validators.required],
    email: [''],
    subject: [''],
    fromName: [''],
  });

  constructor(
    private _messageService: MessageService,
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _documentEmailReadService: DocumentEmailReadService,
    public translate: TranslateService
  ) {}

  goBack() {
    this._router.navigate(['/' + Routes.adminDownloadedDocumentsPage]);
  }

  formatDate(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
  }

  buildRequest(): DocumentEmailReadReportParams {
    const { startDate, endDate, email, subject, fromName } = this.form.value;
    const request: DocumentEmailReadReportParams = {
      startDate: this.formatDate(startDate),
      endDate: this.formatDate(endDate),
    };

    if (email?.trim()) request.email = email.trim();
    if (subject?.trim()) request.subject = subject.trim();
    if (fromName?.trim()) request.fromName = fromName.trim();

    return request;
  }

  downloadReport() {
    if (this.form.invalid) return;

    const { startDate, endDate } = this.form.value;

    if (startDate > endDate) {
      this._messageService.add({
        severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('AdminDownloadedDocuments.Report.InvalidDateRange'),
      });
      return;
    }

    this.loadingBtnDownload = true;
    this._documentEmailReadService.downloadReport(this.buildRequest()).subscribe({
      next: (resultBlob) => {
        excelUtils.downloadExcel(resultBlob.body, 'Downloaded_Documents_Report');
        this.loadingBtnDownload = false;
      },
      error: (e) => {
        console.log(e);
        this.loadingBtnDownload = false;
        this._messageService.add({
          severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('AdminDownloadedDocuments.Report.DownloadError'),
        });
      },
    });
  }
}
